<template>
  <div ref="tooltipEl" class="tooltip" :class="{ hidden: !showTooltip }">
    {{ content }}
    <span class="tooltip-arrow" data-popper-arrow />
  </div>
</template>

<script lang="ts" setup>
import { createPopper, type Instance } from '@popperjs/core'

const showTooltip = ref(false)
const content = ref<string | null>(null)
const timer = ref<ReturnType<typeof setTimeout>>()
const instance = ref<Instance | null>(null)
const tooltipEl = useTemplateRef('tooltipEl')

onMounted(() => {
  document.querySelectorAll('[data-tooltip-content]').forEach((item) => {
    item.addEventListener('pointerover', handleMouseOver, true)
    item.addEventListener('pointerout', handleMouseOut, true)
  })
})

onBeforeUnmount(() => {
  document.querySelectorAll('[data-tooltip-content]').forEach((item) => {
    item.removeEventListener('pointerover', handleMouseOver)
    item.removeEventListener('pointerout', handleMouseOut)
  })
})

const { $i18next, $t } = useNuxtApp()

function handleMouseOver(e: Event) {
  clearTimeout(timer.value)
  timer.value = setTimeout(() => {
    const el = e.target as HTMLElement
    const val = el.getAttribute('data-tooltip-content')
    if (val && $i18next.exists(val)) {
      content.value = $t(val)
    } else {
      content.value = val
    }
    showTooltip.value = true
    if (tooltipEl.value) {
      instance.value = createPopper(el, tooltipEl.value, {
        modifiers: [{ name: 'offset', options: { offset: [0, 8] } }],
      })
    }
  }, 100)
}

function handleMouseOut() {
  clearTimeout(timer.value)
  timer.value = setTimeout(() => {
    showTooltip.value = false
    content.value = null
    instance.value?.destroy()
  }, 100)
}
</script>
